import { onboardingState } from '@/services/Datatypes'
import { StateCreator } from 'zustand'

export interface OnboardingZustandSlice {
    onboardingActive: boolean,
    onboardingState: onboardingState[];

    updateOnboardingActive: (onboardingActive: boolean) => void;
    updateOnboardingState: (state: string, completed: boolean) => void;
    resetOnboarding: () => void;
    getIncompleteStates: () => onboardingState[];

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createOnboardingZustandSlice: StateCreator<OnboardingZustandSlice> = (set, get) => ({
    onboardingActive: true,
    onboardingState: initialOnboardingData,

    updateOnboardingActive: (onboardingActive: boolean) => set(() => ({ onboardingActive: onboardingActive })),
    updateOnboardingState: (state: string, completed: boolean) => {
        set((current) => ({
            onboardingState: current.onboardingState.map(item =>
                item.state == state ? { ...item, completed } : item
            )
        }));
    },
    
    resetOnboarding: () => {
        set(() => ({
            onboardingActive: true,
            onboardingState: initialOnboardingData,
        }));
    },

    getIncompleteStates: () => {
        const currentState = get().onboardingState;
        return currentState.filter((item) => !item.completed);
    },

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});

const initialOnboardingData: onboardingState[] = [
    {
        state: 'showLogin',
        page: 'homescreen',
        completed: false
    },
    {
        state: 'testState',
        page: 'homescreen',
        completed: false
    },
    {
        state: 'Archiv Onboarding',
        page: 'archiv',
        completed: false
    },
    {
        state: 'Login Onboarding',
        page: 'login',
        completed: false
    },
    {
        state: 'Viewer Onboarding',
        page: 'viewer',
        completed: false
    }
];